const baseConfig = {
  appName: process.env.VUE_APP_APP_NAME || '',
  appLogo: require('@/assets/images/logo.jpg'),
  defAvatar: require('@/assets/images/avatar.png'),
  copyright: process.env.VUE_APP_COPYRIGHT || '',
}

module.exports = {
  baseConfig
}
